"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Autocomplete;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _IconTooltip = _interopRequireDefault(require("../IconTooltip"));
require("../Select/styles.scss");
require("./styles.scss");
const isEmpty = value => ['', undefined].includes(value);
function Autocomplete(_ref) {
  let {
    id,
    label,
    options,
    onChange,
    selected,
    filterOptions,
    freeSolo,
    disabled,
    className,
    hideClearIcon,
    isEqual,
    placeholder,
    errorText,
    tooltipTitle,
    required,
    noOptionsText,
    loading,
    loadingText,
    open,
    onOpen,
    onClose,
    sx,
    renderOption
  } = _ref;
  const onChangeHandler = (event, value) => {
    if (event) {
      if (value) {
        onChange(value);
      } else {
        onChange('');
      }
    }
  };
  const renderInput = params => /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "auto-complete ".concat(className),
    sx: sx
  }, label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "textfield-label"
  }, label, " ", required ? '*' : '', tooltipTitle && /*#__PURE__*/_react.default.createElement(_IconTooltip.default, {
    placement: "top",
    title: tooltipTitle
  })), /*#__PURE__*/_react.default.createElement(_material.TextField, Object.assign({}, params, {
    variant: "outlined",
    size: "small",
    placeholder: placeholder,
    className: errorText ? 'auto-complete--error' : ''
  })), errorText && /*#__PURE__*/_react.default.createElement("div", {
    className: "textfield-label-container"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "error",
    className: "textfield-error-text--icon"
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "textfield-error-text"
  }, errorText)));
  const optionalArgs = {};
  if (hideClearIcon) {
    optionalArgs.clearIcon = null;
  }
  if (isEqual) {
    optionalArgs.isOptionEqualToValue = isEqual;
  } else {
    optionalArgs.isOptionEqualToValue = (option, value) => option === value || isEmpty(option) && isEmpty(value);
  }
  return /*#__PURE__*/_react.default.createElement(_material.Autocomplete, Object.assign({
    disabled: disabled,
    id: id,
    options: options,
    getOptionLabel: option => {
      if (typeof option === 'object') {
        var _option$label;
        return (_option$label = option.label) !== null && _option$label !== void 0 ? _option$label : '';
      }
      return option !== null && option !== void 0 ? option : '';
    },
    onChange: onChangeHandler,
    onInputChange: (event, value) => freeSolo && onChangeHandler(event, value),
    value: selected,
    filterOptions: filterOptions,
    freeSolo: freeSolo,
    forcePopupIcon: true,
    renderInput: renderInput,
    "aria-required": required,
    noOptionsText: noOptionsText,
    loading: loading,
    loadingText: loadingText,
    open: open,
    onOpen: onOpen,
    onClose: onClose,
    popupIcon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: loading ? 'spinner' : open ? 'chevronUp' : 'chevronDown',
      className: "auto-complete--icon-right",
      size: "medium"
    }),
    classes: {
      paper: 'auto-complete select',
      listbox: 'options-container'
    },
    sx: {
      '& .MuiAutocomplete-popupIndicator:hover': {
        background: 'transparent'
      },
      '& .MuiAutocomplete-popupIndicator': {
        background: 'transparent',
        transform: 'none'
      },
      '& .MuiTouchRipple-root': {
        display: 'none'
      }
    }
  }, optionalArgs, {
    renderOption: renderOption
  }));
}